import { calculateAge } from "core/utils/date"
import React from "react"

export const COLUMNS1 = [
  {
    Header: "Patient ID",
    accessor: "mocId",
  },
  {
    Header: "Name",
    accessor: (d: any) => (!d?.isVIP ? `${d.title} ${d.name}` : "***Masked***"),
  },
  {
    Header: "Age",
    accessor: (d: any) => {
      return calculateAge(d.dob)
    },
  },
  {
    Header: "Primary Consultant",
    accessor: "primaryConsultantName",
  },
  {
    Header: "Phone No",
    accessor: "phoneNumber",
  },
  {
    Header: "Center",
    accessor: (d: any) => {
      return d?.centers && d?.centers[0] && d?.centers[0]?.centerName
        ? d?.centers[0]?.centerName
        : ""
    },
  },
  {
    Header: "Survival Status",
    accessor: "survivalStatus",
  },
  {
    Header: "Status",
    accessor: "accountStatus",
    Cell: (props: any) => {
      return props?.value?.toLowerCase() === "active" ? (
        <span style={{ color: "green" }}>Active</span>
      ) : (
        <span style={{ color: "red" }}> Inactive</span>
      )
    },
  }
]

export const COLUMNS3 = [
  {
    Header: "Patient ID",
    accessor: "patientId",
  },
  {
    Header: "Patient Name",
    accessor: "patientName",
  },
  {
    Header: "Age",
    accessor: (d: any) => {
      return calculateAge(d.dob)
    },
  },
  {
    Header: "Phone No",
    accessor: (d: any) => {
      return "******" + d.phoneNumber.slice(-4)
    },
  },
  {
    Header: "Center",
    accessor: "centerName",
  },
]

export const COLUMNS4 = [
  {
    Header: "Patient ID",
    accessor: "mocId",
  },
  {
    Header: "Name",
    accessor: (d: any) => (!d?.isVIP ? `${d.title} ${d.name}` : "***Masked***"),
  },
  {
    Header: "Age",
    accessor: (d: any) => {
      return calculateAge(d.dob)
    },
  },
  {
    Header: "Primary Consultant",
    accessor: "primaryConsultantName",
  },
  {
    Header: "Phone No",
    accessor: (d: any) => {
      return "******" + d.phoneNumber.slice(-4)
    },
  },
  {
    Header: "Center",
    accessor: (d: any) => {
      return d?.centers && d?.centers[0] && d?.centers[0]?.centerName
        ? d?.centers[0]?.centerName
        : ""
    },
  },
  {
    Header: "Survival Status",
    accessor: "survivalStatus",
  },
  {
    Header: "Status",
    accessor: "accountStatus",
    Cell: (props: any) => {
      return props?.value?.toLowerCase() === "active" ? (
        <span style={{ color: "green" }}>Active</span>
      ) : (
        <span style={{ color: "red" }}> Inactive</span>
      )
    },
  }
]
